import { render, staticRenderFns } from "./PageForGov.vue?vue&type=template&id=20582094&scoped=true&"
import script from "./PageForGov.vue?vue&type=script&lang=js&"
export * from "./PageForGov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20582094",
  null
  
)

export default component.exports